<style lang="less" scoped>
@import '../../../style/common/variable';
ul,li {margin: 0;padding: 0;list-style: none;}
.rcep{width: 1200px;display: flex;flex-direction: column;background: #f2f2f2;position: relative;margin: 10px auto;}
.navigation {margin-left: 10px !important;}
.center {width: 1200px;margin: auto;display: flex;justify-content: space-between;}
img {vertical-align: middle;}
.first{margin-bottom: 50px;width: 1100px;margin: 10px auto;border: 1px solid #dfdede;}
.title { margin-top: 32px;font-size: 24px;text-align: center;}
.subbox {display: flex;justify-content: center;align-items: space-between;height: 24px;margin: 16px 0px;}
.time {margin-right: 100px;}
.copyfrom{margin-right: 100px;}
@media screen and (max-width: @max-screen){
  .first{width: 96vw; margin-left: 2vw;
    .subbox{display: flex; justify-content: center; align-items: center; flex-direction: column; margin: .3rem 0;
      .time{margin: 0;}
      .copyfrom{margin: 0;}
      .author{margin: 0;}
    }
  }
}
</style>

<template>
  <div class="rcep">
    <Navigation v-if="this.isMobile()" :navigationdatas="navigationListApp" class="navigation"></Navigation>
    <Navigation v-else :navigationdatas="navigationList" class="navigation"></Navigation>
    <div class="center">
      <div class="first">
        <h1 class="title">{{ curArticle.title }}</h1>
        <div class="subbox">
          <span class="time" v-if="curArticle.id">发布时间：{{ curArticle.addtime * 1000 | formatDate() }} </span>
          <span class="copyfrom" v-if="curArticle.id">来源：{{ curArticle.copyfrom }}</span>
          <span class="author" v-if="curArticle.id">作者：{{ curArticle.author }}</span>
        </div>
        <div class="content" v-html="curArticle.curArticleContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * Rcep列表页面
 */
import filters from '../method/filter.js'
import Navigation from '../assembly/Navigation.vue'
export default {
  components: {
    Navigation
  },
  mixins: [filters],
  name: '',
  data()
  {
    return {
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: 'RCEP业务专栏', path: ''},
        {theme: '', path: ''}
      ],
      navigationListApp: [
        {theme: '首页', path: '/KyforumApp'},
        {theme: 'RCEP业务专栏', path: ''},
        {theme: '', path: ''}
      ],
      curArticle: {
        addtime: null,
        author: '',
        catid: null,
        copyfrom: '',
        edittime: null,
        hits: 0,
        id: null,
        title: '',
        curArticleContent: ''
      },
      widthCSH: 1200
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.$nextTick(() =>
        {
          this.getData(+nval.query.id)
        })
      },
      immediate: true
    }
  },
  created()
  {
  },
  methods: {
    goList(item)
    {
      let url = this.$router.resolve({path: '/RcepLB', query: {catid: item.id}})
      window.open(url.href, '_blank')
    },
    getData(id)
    {
      // 获取对应分类的数据
      let paras = {cmd: 'query', _major: 11, _minor: 107, _exp: `id=${id}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.curArticle.addtime = ret[0].addtime
        this.curArticle.author = ret[0].author
        this.curArticle.catid = ret[0].catid
        this.curArticle.copyfrom = ret[0].copyfrom
        this.curArticle.edittime = ret[0].edittime
        this.curArticle.hits = ret[0].hits
        this.curArticle.id = ret[0].id
        this.curArticle.title = ret[0].title
        let paras1 = {cmd: 'query', _major: 11, _minor: 108, _exp: `id=${id}`}
        window.post.getPost(paras1).then((ret1) =>
        {
          this.curArticle.curArticleContent = window.public.decodeContent(ret1[0].content)
        })
        let paras2 = {cmd: 'query', _major: 99, _minor: 20, _exp: `id=${ret[0].catid}`}
        window.post.getPost(paras2).then((ret2) =>
        {
          this.navigationList[this.navigationList.length - 1].theme = ret2[0].dispc
        })
      })
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/RcepDetails.vue